import {
  TradeDirection,
  TradeFlow,
} from '../../graphQL/types/shared';
import memoize from '../../memoize';
import {
  DataSource,
  ICPYDatum,
  ILoadable,
  LoadableStatus,
} from '../../Utils';
import {
  IMetadatum,
} from '../fetchedData/countryMetadata';
import unmemoizedGetSize from '../network/getSize';
import unmemoizedGetTradeValueGetter from '../rings/getTradeValueGetter';
import unmemoizedAssignValueAndPct from './assignValuesAndPct';
import {
  IComputationOutput,
} from './Utils';

const getId = ({location_id}: ICPYDatum) => location_id;

export interface IComputationInput {
  source: DataSource.CPY;
  mainData: ILoadable<ICPYDatum[]>;
  metadata: ILoadable<Map<number, IMetadatum>>;
  levelMapping: ILoadable<Map<number, number>>;
  tradeDirection: TradeDirection;
  tradeFlow: TradeFlow;
  primaryCountry: undefined;
  year: number;
  width: number | undefined;
  height: number | undefined;
}

const getTradeValue = memoize(unmemoizedGetTradeValueGetter);
const assignValueAndPct = memoize(unmemoizedAssignValueAndPct);
const getSize = memoize(unmemoizedGetSize);

const compute = (
    computationInput: IComputationInput,
  ): ILoadable<IComputationOutput> => {

  const {
    metadata: metadataStatus,
    levelMapping: levelMappingStatus,
    mainData: mainDataStatus,
    tradeDirection, tradeFlow,
    primaryCountry, year,
    width, height,
    queryLevel,
    groupsMetadata: groupsMetadataStatus, 
    groupMembersMetadata: groupMembersMetadataStatus
  } = computationInput;

  const sizeStatus = getSize(width, height);

  
  let result: ILoadable<IComputationOutput>;
  if (metadataStatus.status === LoadableStatus.Initial ||
      levelMappingStatus.status === LoadableStatus.Initial ||
      mainDataStatus.status === LoadableStatus.Initial ||
      sizeStatus.status === LoadableStatus.Initial ||
      groupsMetadataStatus.status === LoadableStatus.Initial ||
      groupMembersMetadataStatus.status === LoadableStatus.Initial) {

    result = {status: LoadableStatus.Initial};

  } else if (metadataStatus.status === LoadableStatus.Loading ||
      levelMappingStatus.status === LoadableStatus.Loading ||
      mainDataStatus.status === LoadableStatus.Loading ||
      sizeStatus.status === LoadableStatus.Loading ||
      groupsMetadataStatus.status === LoadableStatus.Loading ||
      groupMembersMetadataStatus.status === LoadableStatus.Loading) {

    result = {status: LoadableStatus.Loading};
  } else if (metadataStatus.status === LoadableStatus.NotPresent ||
      levelMappingStatus.status === LoadableStatus.NotPresent ||
      mainDataStatus.status === LoadableStatus.NotPresent ||
      sizeStatus.status === LoadableStatus.NotPresent ||
      groupsMetadataStatus.status === LoadableStatus.NotPresent ||
      groupMembersMetadataStatus.status === LoadableStatus.NotPresent) {

    result = {status: LoadableStatus.NotPresent};
  } else {
    const {data: metadata} = metadataStatus;
    const {data: mainData} = mainDataStatus;
    const {data: levelMapping} = levelMappingStatus;
    const {data: size} = sizeStatus;
    const {data: groupsMetadata} = groupsMetadataStatus;
    const {data: groupMembersMetadata} = groupMembersMetadataStatus;

    const getValue = getTradeValue(tradeDirection, tradeFlow);
    const output = assignValueAndPct(
      getId, getValue, mainData, primaryCountry, metadata, levelMapping,
      tradeDirection, tradeFlow, year, size.width, size.height, queryLevel, groupsMetadata, groupMembersMetadata
    );
    result = {
      status: LoadableStatus.Present,
      data: output,
    };
  }
  return result;
};

export default compute;
